<script>
  import Auth from './components/Auth.svelte';
  import StrapiPage from './components/StrapiPage.svelte';
  import AiChatWidget from './components/AiChatWidget.svelte';

  let path = window.location.pathname;
  let showAdmin = path.startsWith('/admin');

  // --- AUTH ---
  let authed = false;

  function checkAuth() {
    const token = localStorage.getItem("token");
    if (!token) {
      authed = false;
      return;
    }

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const now = Date.now() / 1000;
      authed = payload.exp && payload.exp > now;
      if (!authed) localStorage.removeItem("token");
    } catch {
      authed = false;
      localStorage.removeItem("token");
    }
  }

  checkAuth();

  if (typeof window !== "undefined") {
    window.addEventListener("storage", (e) => {
      if (e.key === "token") checkAuth();
    });
  }
</script>

{#if showAdmin}
  {#if authed}
    <StrapiPage title="ALADV Admin" />
    <AiChatWidget />
  {:else}
    <Auth />
  {/if}
{:else}
  <StrapiPage title="ALADV" />
{/if}
